<template>
  <div class="page_title">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="page_title-content">
            <p>
              Welcome Back
              <span v-if="curLoginUser.realName"> , {{ curLoginUser.realName }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { amountlistinfo } from "../../plugins/api/amount";
import store from "@/store/index";
export default {
  data() {
    return {
      show: false,
      amount: {},
      curLoginUser: {},
    };
  },
  created() {
    this.curLoginUser = store().getters.curLoginUser;
  },
};
</script>
